// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Pzp3","title":"Images90_title__m1cie","images":"Images90_images__3L8a-"};